import React, {useMemo} from 'react'
import {expandReference,  deadlineObjectChecker} from '../../lib/utils';
import {ViewLabelValueField,VisDiv } from '../../components';
import {useStateContext} from '../../context/StateContext';

import {DataScadenzaCollaudoRevisione} from '../../lib/ScadenzeData'


/**
 * Component to display deadlines for a device with Collaudo and Revisione deadlines
 * #deadlines
 * @param {object} device - The device object
 * @param {object} deviceTemplate - The device template object
 * @param {object} registerTemplate - The register template object
 *  
 * @returns {JSX.Element} A JSX element displaying the deadlines
 */
const ScadenzaCollaudoRevisione = ({device, deviceTemplate, registerTemplate}) => {

    const testing = false
    const data = useMemo(() => (DataScadenzaCollaudoRevisione(device, deviceTemplate, registerTemplate)),[device,deviceTemplate, registerTemplate]);
    const {expiry, collaudo, revisione, maintenanceTasksList} = data


    const testFunction = () => {
        //console.log(DataScadenzaCollaudoRevisione(device, deviceTemplate, registerTemplate))
    }

        return (
            <div>
                <VisDiv rules={[testing]}><button onClick={()=>{testFunction()}}>Test deadlines</button></VisDiv>
                {revisione?.dateObject && <ViewLabelValueField
                    label={revisione?.label}
                    value={ deadlineObjectChecker(revisione?.dateObject).date}
                    highlight={ deadlineObjectChecker(revisione?.dateObject).color}
                    
                />}
                { collaudo?.dateObject &&
                <ViewLabelValueField
                    label={collaudo?.label}
                    value={ deadlineObjectChecker(collaudo?.dateObject).date}
                    highlight={ deadlineObjectChecker(collaudo?.dateObject).color}

                />}
                { expiry?.dateObject && 
                <ViewLabelValueField
                    label={expiry?.label}
                    value={ deadlineObjectChecker(expiry?.dateObject).date}
                    highlight={ deadlineObjectChecker(expiry?.dateObject).color}
                />}

            </div>
        )
    

}

export default ScadenzaCollaudoRevisione
